import { createComponent } from '@carvana/merch-components';
import { datadogRum } from '@datadog/browser-rum';
import { useTrackEvent } from '~/context/srp/SearchAnalyticsContext';
import { useTileDataContext } from '~/context/srp/TileDataContext';
import { useAltText, useImageUrl, useNoVehicle } from './hooks';
import { useIsMarketPlace } from '../../hooks';

const getOptimizedUrl = (url: string, width: number) => {
  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}width=${width}`;
};

const TilePicture = createComponent('picture', {
  className:
    'absolute bg-gradient-to-t block bottom-0 from-[#EDF5F8] h-full rounded-t-md to-white top-0 via-white w-full'
});

const tileImageClasses = 'h-full object-cover rounded-t-md w-full';

const VehicleImage = () => {
  const altText = useAltText();
  const imageToUse = useImageUrl();
  const isMarketplace = useIsMarketPlace();
  const noVehicle = useNoVehicle();
  const { tileData } = useTileDataContext();
  const trackEvent = useTrackEvent();
  const hasBlueSteel = imageToUse === tileData?.jellyBeanMobileUrl;

  const handleFailedLoad = () => {
    if (trackEvent == null) return;
    const eventData = {
      id: tileData?.vehicleId,
      imageUrl: imageToUse
    };
    trackEvent('Tile Image Load Failed', eventData);
    datadogRum.addAction('tile-image-load-failed', eventData);
  };

  if (noVehicle) {
    return <TilePicture data-qa="vehicle-image" />;
  }

  return (
    <TilePicture data-qa="vehicle-image">
      {isMarketplace ? (
        <>
          <source media="(min-width: 0px)" srcSet={imageToUse} />
          <img
            className={tileImageClasses}
            src={imageToUse}
            alt={altText}
            loading="lazy"
            onError={() => handleFailedLoad()}
          />
        </>
      ) : (
        <>
          <source
            media="(min-width: 650px)"
            srcSet={getOptimizedUrl(imageToUse, 449)}
            onError={() => handleFailedLoad()}
          />
          <source
            media="(min-width: 0px)"
            srcSet={getOptimizedUrl(imageToUse, 347)}
            onError={() => handleFailedLoad()}
          />
          <img
            className={tileImageClasses}
            src={getOptimizedUrl(imageToUse, 347)}
            alt={altText}
            loading="lazy"
            onError={() => handleFailedLoad()}
          />
        </>
      )}
      {hasBlueSteel && (
        <span className="absolute bottom-[5px] right-[25%] text-black text-xs translate-y-[-75%]">
          {'\xA9  Carvana, LLC Stock Image'}
        </span>
      )}
    </TilePicture>
  );
};

export default VehicleImage;
